/**
 * Copyright (C) Sitevision 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-file-portlet')) {
  import(/* webpackChunkName: "file-portlet" */ './file.css');
}
